import { isWebBrowser } from '@garnish/core';

export const checkIfHasPointerDevice = () =>
  isWebBrowser() && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
